module.exports = __webpack_public_path__ + "img/res-icon-20.efe72516.png";